import { StackedBarGraphWrapper } from './wrapper';
import { StackedBarGraphKnobs } from './knobs';
import { StackedBarChartWidget } from './index';
import { propertyHierarchy } from 'widgets/endpoints';
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { filterProperties } from 'utilities/srsUtils';
import { DefaultChartColorScales } from 'styles/chartColors';

const flags = [SrsPropertyFlag.Categorical];

export const config = {
	key: 'STACKED_BAR_GRAPH',
	label: 'Stacked Bar',
	icon: 'full-stacked-chart',
	wrapper: StackedBarGraphWrapper,
	widget: StackedBarChartWidget,
	endpoint: propertyHierarchy,
	Knobs: StackedBarGraphKnobs,
	flags: flags,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					JoinMethod: 'InnerJoin',
					maxRoot: 20,
					maxNodes: 1000,
					metadata: [filteredProperties[1].name],
					sortList: [
						{sort: "count", direction: "descending", label: "Count Descending"},
						{sort: "count", direction: "descending", label: "Count Descending"}
						]
				},
			},
		};
	},
	createDefaultConfiguration: (_filteredProperties) => {
		// we default to settings that make sense for a simple bar graph
		return {
			showXAxis: true,
			showYAxis: true,
			showTotals: true,
			showValuesInBarStacks: false,
			colorScale: DefaultChartColorScales['Single Color'],
			direction: 'auto',
			showLegend: false,
			showBarLabels: false,
			limitAxisLabels: true,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, flags).length >= 1;
	},
};
